import { render, staticRenderFns } from "./Modifyadd.vue?vue&type=template&id=4f811344"
import script from "./Modifyadd.vue?vue&type=script&lang=js"
export * from "./Modifyadd.vue?vue&type=script&lang=js"
import style0 from "./Modifyadd.vue?vue&type=style&index=0&id=4f811344&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports